export default __webpack_public_path__ + "static/low-fi-dark-51888568f0a1c4fb8120fa2c9c5d4f1d.png";